var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9748 12.0002C14.9748 12.1335 14.9498 12.2625 14.8998 12.3872C14.8498 12.5125 14.7831 12.6169 14.6998 12.7002L10.0998 17.3002C9.91647 17.4835 9.68314 17.5752 9.3998 17.5752C9.11647 17.5752 8.88314 17.4835 8.6998 17.3002C8.51647 17.1169 8.4248 16.8835 8.4248 16.6002C8.4248 16.3169 8.51647 16.0835 8.6998 15.9002L12.5998 12.0002L8.6998 8.1002C8.51647 7.91686 8.4248 7.68353 8.4248 7.4002C8.4248 7.11686 8.51647 6.88353 8.6998 6.7002C8.88314 6.51686 9.11647 6.42519 9.3998 6.42519C9.68314 6.42519 9.91647 6.51686 10.0998 6.7002L14.6998 11.3002C14.7998 11.4002 14.8705 11.5085 14.9118 11.6252C14.9538 11.7419 14.9748 11.8669 14.9748 12.0002Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.68d3018742e510f6c955984b227a887f.svg";
export { ForwardRef as ReactComponent };